import { useAppSelector } from "lib/store";
import ModalTitle from "../ModalTitle";
import styles from './propertyContact.module.css';
import {
  getActiveNotificationsMessagesById,
} from "_slices/notifications";
import { useNotificationLocation } from "lib/hooks/useNotificationLocation";
import useMount from "react-use/lib/useMount";
import logRepContact from "lib/ga/repContact"

import Contact from "../Contact";

type Props = {
  title: string,
  subTitle: string,
  property: {
    name: string,
    type: string,
    id: string,
    hasBid: boolean
    premium: boolean
    address: {
      line2: string,
      line1: string,
      postcode: string,
      town_name: string
    }
  },
  user: {
    forename: string,
    surname: string,
    email: string,
    telephone: string,
    company: {
      name: string
    }
  }
  agents: {
    company_name: string,
    company_id: number,
    logo_uri: string
  }[],
  closeModal: any,
  id: string
}

const PropertyContact = ({ title, subTitle, property, user, closeModal, agents, id }: Props) => {
  useMount(() => {
    // Log that the modal has been opened and how is being contacted
    logRepContact({
      type: "email",
      state: "opened",
      target: '',
      id: id,
      subject_type: property?.type
    })
  })

  title = title || "Schedule a Call";
  subTitle = subTitle || "";
  let notification_id = 'MODAL_PROPERTY_CONTACT_FORM';
  const [sendSuccess, activeNotifications] = useNotificationLocation(notification_id);

  return <>
    <ModalTitle title={title} containerMargin="1rem" />
    {!sendSuccess && activeNotifications &&
      activeNotifications.map((id) => {
        return <NotificationMessage key={id} id={id} />;
      })}
    {agents && agents.length > 0 && <div className={styles.AgentsLogoContainer}>
      {agents.map((agent) => {
        if (!agent.logo_uri) return null;
        return <div className={styles.AgentsLogo} key={agent.company_id}>
          <img alt={`${agent.company_name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${agent.logo_uri}`}></img>
        </div>
      })}
    </div>}
    <div className={styles.PropertyContainer}>
      <div>{property.name}</div>
      <div>{['line1', 'line2', 'town_name'].map((k) => property.address[k]).filter(Boolean).join(', ')}</div>
    </div>

    <div className={styles.FormTitle}>
      Send A Message
    </div>
    <Contact googleCat='Property Contact' googleType='email' property={property} user={user} agentList={[]} closeModal={closeModal} premium={property.premium ? 1 : 0} agentId={null} />
  </>
};

export default PropertyContact;

interface NotificationMessageProps {
  id: string;
}
const NotificationMessage = ({ id }: NotificationMessageProps) => {
  let messages = useAppSelector((state) => getActiveNotificationsMessagesById(id, state));

  return (
    <div className={`${styles.AlertDanger} ${styles.Alert}`} key={id}>
      {messages.map((message) => {
        return <div key={id}>{message}</div>;
      })}
    </div>
  );
};
